export default "__VITE_ASSET__fK8v4Qoc__"